import { PageController } from '@client/components/_core/layout/PageController';
import { PublicComplaintForm } from '@client/components/complaints/PublicComplaintForm';
import {
    buildPublicFieldConfigurationsInput,
    CONFIG_LOOKUP_QUERY_OPTIONS,
    PUBLIC_COMPLAINT_FIELD_SECTIONS,
} from '@client/trpc/query-options';
import type { ShareableRouteContext } from '@client/types/router';
import { SYSTEM_ORG_IDS } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/public/$orgId/complaint/new')({
    beforeLoad: ({ context, params }): ShareableRouteContext => {
        // Brand config and both custom-field sections are prefetched concurrently with
        // the parent route's org-settings prefetch — they used to be strictly serial
        // (outlet gated on org settings, then the mounted form fetched brand config and
        // field configurations). CUR-1036 task 2.1; field configurations CUR-1588.
        // Mirror the parent route's guard: below the first valid org ID it never renders
        // its outlet, so nothing would read these prefetches.
        if (params.orgId >= SYSTEM_ORG_IDS.FIRST_VALID_ORG_ID) {
            void context.trpcUtils.complaint.getBrandConfig.prefetch(
                { orgId: params.orgId },
                { ...CONFIG_LOOKUP_QUERY_OPTIONS, meta: { errorSurface: 'silent', captureToSentry: false } },
            );
            for (const section of PUBLIC_COMPLAINT_FIELD_SECTIONS) {
                void context.trpcUtils.fieldConfiguration.listPublicFieldConfigurations.prefetch(
                    buildPublicFieldConfigurationsInput({ orgId: params.orgId, entity: 'COMPLAINT', section }),
                    { ...CONFIG_LOOKUP_QUERY_OPTIONS, meta: { errorSurface: 'silent', captureToSentry: false } },
                );
            }
        }
        return undefined;
    },
    component: ComplaintNewPage,
});

function ComplaintNewPage() {
    return (
        <PageController route={Route}>
            <PublicComplaintForm />
        </PageController>
    );
}
